export default {
  TaskDetail: {},
  readTask: false, // tp0是否已经
  readReject: false, // 驳回任务是否已读
  options: {
    taskStatus: ['100', '200', '250'], // 默认未完成
    taskTypeId: [],
    taskPriority: [],
    displayDimension: 1, // 默认商家维度
    taskTypeTag: [], // 任务类型标签
    teamBelong: [], // 任务创建团队
    taskConfig: {
      dispatch_mode_list: [],
      exec_pre_cond_list: [],
      apply_mode_list: [],
      entity_type_list: [],
      executor_type_list: [],
      notice_mode_list: [],
      task_priority_list: [],
      task_status_list: [],
    },
    remarkList: [],
  },
}
